import { loader } from 'graphql.macro'

export default function dispatcherTransactions ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./dispatcherTransactions.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    invoiceId: variables.invoiceId
  })
}
